import { useLoad } from "@allergy123/api-client/react";
import { Card, Status, Table, Td, Th } from "@allergy123/ui";
import { Link, useSearchParams } from "react-router";
import { CatalogHeader, errorText } from "./common";

const show = (e: { prevalence: string | null; severity: string | null; seasons: string[] } | null) => (e ? `prevalence ${e.prevalence ?? "—"} · severity ${e.severity ?? "—"} · ${e.seasons.join(", ") || "no seasons"}` : "no entry");

export function ProfileComparePage() {
  const [params] = useSearchParams();
  const a = params.get("a") ?? "";
  const b = params.get("b") ?? "";
  const data = useLoad((api) => api.admin.catalog.compareProfiles(a, b), [a, b]);
  const cmp = data.data;
  return (
    <>
      <CatalogHeader title="Compare allergen profiles" intro="Antigens whose prevalence, severity or seasons differ between two versions or two profiles." />
      {data.state === "error" && <div className="mb-6"><Status kind="error" label={`Couldn't compare (${errorText(data.error)})`} /></div>}
      {data.state === "loading" && <p className="text-ink-secondary">Loading…</p>}
      {cmp && (
        <Card>
          <p className="mb-4 flex flex-wrap gap-4 text-small">
            <Link to={`/catalog/profiles/versions/${cmp.a.id}`} className="text-anchor underline">Open {cmp.a.family.code} v{cmp.a.version}</Link>
            <Link to={`/catalog/profiles/versions/${cmp.b.id}`} className="text-anchor underline">Open {cmp.b.family.code} v{cmp.b.version}</Link>
          </p>
          <Table caption={`${cmp.a.family.code} v${cmp.a.version} → ${cmp.b.family.code} v${cmp.b.version}: ${cmp.differences.length} difference(s)`}>
            <thead>
              <tr>
                <Th>Antigen</Th>
                <Th>{cmp.a.family.code} v{cmp.a.version}</Th>
                <Th>{cmp.b.family.code} v{cmp.b.version}</Th>
              </tr>
            </thead>
            <tbody>
              {cmp.differences.map((d) => (
                <tr key={d.antigenId}>
                  <Td>{d.displayName}</Td>
                  <Td>{show(d.a)}</Td>
                  <Td>{show(d.b)}</Td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Card>
      )}
    </>
  );
}
